const key = 'ielts.mock.homework-session';
const bindingKey = 'ielts.mock.homework-record';

function currentRecordId() {
  const match = window.location.hash.match(/^#\/mock(?:start|listening(?:ai)?|reading(?:ai)?|writing(?:ai)?)\/(\d+)(?:[/?#]|$)/);
  return match ? Number(match[1]) : undefined;
}

export function hasMockHomeworkBinding() {
  const recordId = currentRecordId();
  return recordId !== undefined && sessionStorage.getItem(bindingKey) === String(recordId);
}

export interface MockHomeworkSession {
  token: string;
  recordId: number;
  expiresAt: string;
  mode?: string;
  allowWrite?: boolean;
  transport?: 'teacher' | 'student';
}

export function isMockHomeworkContext() {
  return hasMockHomeworkBinding() || /^#\/(?:launch|teacher-launch|practice-launch)(?:[/?]|$)/.test(window.location.hash);
}

export function setMockHomeworkSession(session: MockHomeworkSession) {
  sessionStorage.setItem(key, JSON.stringify(session));
  sessionStorage.setItem(bindingKey, String(session.recordId));
}

export function getMockHomeworkSession(): MockHomeworkSession | undefined {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return;
    const session = JSON.parse(raw) as MockHomeworkSession;
    if (!session.token || !Number.isSafeInteger(session.recordId) || session.recordId <= 0 || !Number.isFinite(Date.parse(session.expiresAt)) || Date.parse(session.expiresAt) <= Date.now()) {
      sessionStorage.removeItem(key); return;
    }
    if ((session.transport === 'teacher') !== (session.mode === 'teacher_sandbox' || session.mode === 'assignment_preview')) { sessionStorage.removeItem(key); return; }
    // A scoped session must never affect a different ordinary mock record.
    if (currentRecordId() !== session.recordId) return;
    return session;
  } catch { sessionStorage.removeItem(key); }
}

export function mockHomeworkRequest(url: string, body: any) {
  const session = getMockHomeworkSession();
  if (!session) {
    if (hasMockHomeworkBinding()) throw new Error('作业会话已失效，请返回作业重新开始。');
    return;
  }
  const action = url === '/api/student/get-info' ? 'profile'
    : url.startsWith('/api/simulate/') ? url.slice('/api/simulate/'.length) : undefined;
  if (!action) {
    if (url.startsWith('/api/') && !url.startsWith('/api/practice/')) throw new Error('当前作业会话不支持此操作。');
    return;
  }
  const prefix = session.transport === 'teacher' ? '/api/workspace/practice/teacher' : '/api/practice/session';
  return { url: `${prefix}/mock/${action}`, body: { ...body, record_id: session.recordId }, token: session.token };
}

export function isMockHomeworkPreview() {
  return getMockHomeworkSession()?.mode === 'assignment_preview';
}

export function isTeacherMockContext() {
  const session = getMockHomeworkSession();
  return session?.transport === 'teacher' || (!session && hasMockHomeworkBinding());
}
